export const getApiUrl = () => {
  const envUrl = import.meta.env.VITE_API_URL as string | undefined

  if (!envUrl) {
    return '/query'
  }

  if (envUrl.endsWith('/query')) {
    return envUrl
  }

  return `${envUrl.replace(/\/$/, '')}/query`
}
